module.exports = __webpack_public_path__ + "img/fa-brands-400.ee0e08b8.svg";